module.exports = __webpack_public_path__ + "static/media/QuestionMarkIcon.e91b0176.svg";